import { AntTabs } from './styles';

export default AntTabs;
